import Env from "config/environment";

const { isTestMarketingEnvironment, hostName } = Env;

export const marketingHost = Env.marketingHost;
export const reswareDocumentationHost = "https://notarize.com/knowledge-center/resware-notarize";
export const businessDemoUrl = "https://notarize.tourial.com/pages/notarize-for-business";
export const businessInfoUrl = `${marketingHost}/solutions/for-business`;
export const proofCapabilitiesUrl = "https://www.proof.com/capabilities";
export const notarizeAcademyUrl = `${marketingHost}/academy/real-estate-academy`;
export const paperRecordingBlogPost = `${marketingHost}/blog/what-you-need-to-know-about-papering-out-and-recording-electronic-records`;
export const legalInfoUrl = `${marketingHost}/legal`;
export const businessMarketingResourceUrl = `${marketingHost}/business-marketing-resource-center`;
export const notaryMarketingResourceUrl = "https://notarize.com/notary/resource-center";
export const notaryStateComplianceUrl = `${marketingHost}/compliance`;
export const contactSalesUrl = `${marketingHost}/contact-sales`;
export const tierPricingUrl = isTestMarketingEnvironment
  ? `${marketingHost}/pricing?env=${encodeURIComponent(hostName)}`
  : `${marketingHost}/pricing`;
export const titlePricingUrl = isTestMarketingEnvironment
  ? `${marketingHost}/pricing?env=${encodeURIComponent(hostName)}#title`
  : `${marketingHost}/pricing#title`;
export const businessPricingUrl = isTestMarketingEnvironment
  ? `${marketingHost}/pricing?env=${encodeURIComponent(hostName)}#business`
  : `${marketingHost}/pricing#business`;
export const lenderPricingUrl = isTestMarketingEnvironment
  ? `${marketingHost}/pricing?env=${encodeURIComponent(hostName)}#loan`
  : `${marketingHost}/pricing#loan`;
export const proofLenderPricingUrl = isTestMarketingEnvironment
  ? `https://proof.com/pricing?env=${encodeURIComponent(hostName)}#mortgage`
  : "https://proof.com/pricing#mortgage";
export const newIaAnnouncementUrl = `${marketingHost}/blog/new-platform-navigation`;
export const newBrandAnnouncementOrgUrl = `${marketingHost}/blog/meet-proof`;
export const newBrandAnnouncementNotaryUrl = `${marketingHost}/blog/how-proof-benefits-notaries`;
export const mobileUrl = `${marketingHost}/mobile`;
export const proofRebrandUrl = "https://proof.com/blog/platform-rebrand";
export const notarizeNotaryUrl = "https://notarize.com/notary";
